<template>
  <div>
    <label for="input-name">Name *: </label>
    <b-form-input
      id="input-name"
      v-model="formData.applicationDetails.name"
      type="text"
      required
      :state="validName"
      aria-aria-describedby="input-name-feedback"
      placeholder="Nachname"/>
    <b-form-invalid-feedback id="input-name-feedback">Mindestens 3 Buchstaben</b-form-invalid-feedback>
    <label for="input-email">eMail *: </label>
    <b-form-input
      id="input-email"
      v-model="formData.applicationDetails.email"
      type="email"
      required
      :state="validEmail"
      placeholder="eMail"/>
    <label for="textarea-notice">Freitext: </label>
    <b-form-textarea
      id="textarea-freeText"
      v-model="formData.applicationDetails.freeText"
      type="text"
      rows="2"
      max-rows="4"
      no-resize
      placeholder="Anmerkungen"/>
  </div>
</template>

<script>
export default {
  name: 'delivery-details',
  version: '0.0.1',
  props: {
    // age18Reqrd: {
    //   type: Boolean,
    //   default: false
    // }
  }, // props
  components: {}, // components
  data () {
    return {
      loaded: false,
      info: '... loading content!',
      infoStyle: { 'text-align': 'left', color: 'black' },
      // formData: {}
      formData: {
        applicationDetails: {
          name: null,
          email: null,
          freeText: ''
        }
      }
    }
  }, // data
  /* ----- vuejs hooks ----- */
  mounted () {}, // mounted
  computed: {
    validName: function () {
      return this.formData.applicationDetails.name?.length > 1 &&
        this.formData.applicationDetails.name?.length < 20
    }, // validName
    validEmail: function () {
      const re = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+(?:[A-Z]{2}|com|org|net|gov|mil|biz|info|mobi|name|aero|jobs|museum)\b$/i
      return re.test(this.formData.applicationDetails.email)
    }, // validEmail
    validFormData: function () {
      return this.validName && this.validEmail
    }
  }, // computed
  watch: {
    validFormData: function () {
      console.log('TRACE-REMOVE: validFormData changed: ', this.validFormData)
      this.$emit('valid-form-data-changed', this.validFormData)
    } // validFormData
  }, // watch
  methods: {} // methods
}
</script>

<style lang="scss" scoped>
</style>
